






































import {Component, Watch, Vue} from "vue-property-decorator";
import {Player, PlayerDigit} from "@/classes/Player.ts";
import Guess from "@/classes/Guess.ts";
import Config from "@/classes/Config.ts";
import GameManager from "@/classes/GameManager.ts";
import DigitSelector from "@/components/Game/DigitSelector.vue";
import DigitGuessModule from "@/components/Game/DigitGuessModule.vue";
import GameState from "@/enums/GameState";

@Component({
    components: {
        DigitSelector, DigitGuessModule
    }
})
export default class HackGame extends Vue {
    public player = new Player();
    public guesses: Guess[] = [];
    public remainingAttempts: number = Config.TOTAL_ATTEMPTS;
    public guessStep: number = -1;

    public created(): void {
        for (let i = 0; i < Config.DIGIT_COUNT; i++) {
            this.player.digits.push({id: i, value: 0, guessed: false} as PlayerDigit);
        }
    }

    public guessPassword(): void {
        const guess = new Guess(this.player.digitsAsArray(), GameManager.digitArray);
        this.guesses.push(guess);

        // Mark digit selector as 'guessed' if digit was correct
        for (let i = 0; i < Config.DIGIT_COUNT; i++) {
            const playerDigit = this.player.digits[i];
            if (playerDigit.guessed) {
                continue;
            }

            const guessDigit = guess.digits[i];
            if (guessDigit.isCorrectPosition) {
                playerDigit.guessed = true;
            }
        }

        if (guess.guessIsCorrect) {
            this.$store.commit("setGameState", GameState.Success);
            GameManager.playSound("HACKSUCC");
        } else {
            this.remainingAttempts--;
            GameManager.playSound("MSELECT1");
            if (this.remainingAttempts === 0) {
                this.$store.commit("setGameState", GameState.Failure);
                GameManager.playSound("MDONE");
            }
        }
    }

    @Watch("remainingAttempts")
    public updateGuessStep(): void {
        this.guessStep = Config.TOTAL_ATTEMPTS - this.remainingAttempts - 1;
    }
}
